// Feature Flag Manager and Explorer sources only. Add Feature Flag Portal tracking (flags, templates,
// entity ops) to pages/featureFlagPortal/sources.ts. Both files share the 130xx ID range, so check both.
export const FEATURE_FLAGS_CHANGE_TRACKING = {
  managerRefreshCache: {
    source: 'feature_flags.manager.refresh_cache',
    id: 13001,
  },
  managerUpdateFlag: {
    source: 'feature_flags.manager.update_flag',
    id: 13002,
  },
  managerOverrideAdd: {
    source: 'feature_flags.manager.override.add',
    id: 13003,
  },
  managerOverrideUpdate: {
    source: 'feature_flags.manager.override.update',
    id: 13004,
  },
  managerOverrideDelete: {
    source: 'feature_flags.manager.override.delete',
    id: 13005,
  },
  explorerRefreshCache: {
    source: 'feature_flags.explorer.refresh_cache',
    id: 13006,
  },
  explorerOverrideAdd: {
    source: 'feature_flags.explorer.override.add',
    id: 13007,
  },
  explorerOverrideUpdate: {
    source: 'feature_flags.explorer.override.update',
    id: 13008,
  },
} as const;
